// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ErrorReporter__message{font-family:monospace;font-weight:700;margin:20px;color:#000}.ErrorReporter__traceback{font-family:monospace;margin:20px;white-space:pre-wrap;color:#d3d3d3}", ""]);
// Exports
module.exports = exports;
